// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actived[data-v-759308ac] {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgba(98, 63, 153, var(--tw-bg-opacity)) !important;\n  --tw-text-opacity: 1 !important;\n  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;\n}\n", ""]);
// Exports
module.exports = exports;
